/* eslint-disable react/prop-types */
import React from 'react';
import { P } from '@contently/toolkit';

const PillarCell = ({ cell }) => <P>{cell.value || 'No Pillar'}</P>;

export default PillarCell;



// WEBPACK FOOTER //
// ./app/javascript/app/components/story_level_value/PillarCell.jsx